/*
 * File: getProduct.tsx
 * Project: meki
 * File Created: Monday, 28th September 2020 11:38:59 am
 * Author: Vicente Melin (vicente@inventures.cl)
 * -----
 * Last Modified: Wednesday, 15th December 2021 5:23:37 pm
 * Modified By: Luis Aparicio (luis@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

import { gql } from '@apollo/client';
import { Product } from '@interfaces';
import { ResolverParams } from '@queries/queries.interfaces';

export const getProduct = (name: string) => gql`
  query ${name}($params: ProductParams!) {
    product(params: $params ){
      id
      uuid
      slug
      name
      description
      price
      discount {
          price
          type
          stockRestriction
          dateRestriction
          listPrice
        }
      concentration
      prescriptionType
      unit
      quantity
      package
      composition
      posology
      display
      contraindications
      indications
      containerQuantity
      container
      metadata {
        ispRegister
        refrigerated
      }
      relatedProducts(relation: "bioequivalente") {
        id
        uuid
        slug
        name
        activePrinciple
        description
        price
        discount {
          price
          type
          stockRestriction
          dateRestriction
          listPrice
        }
        concentration
        availability {
          status
          stock
          statusWithoutStock
          discountStock
        }
        format
        laboratory
        imagesUrl
        prescriptionType
        unit
        quantity
        isBioequivalent
        isCheapestActivePrinciple
      }
      availability {
        status
        statusWithoutStock
        stock
        discountStock
      }
      imagesUrl
      format
      isBioequivalent
      activePrinciple
      laboratory
      externalPrices {
        amount
        saleAmount
        seller
        lastUpdate
      }
      isCenabast
      isMedicine
      thumbnailUrl
      isCheapestActivePrinciple
    }
  }
  `;

export type getProductQueryParams = ResolverParams<{
  slug?: string;
  uuid?: string;
}>;

export type getProductQueryResponse = { product: Product };
